<template>
  <b-modal id="update-care" hide-footer @hide="onModalHide">
    <template v-slot:modal-title>Editar Cuidado</template>
    <div class="d-block">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <LabelRequiredField label="Nome" />

            <input
              type="text"
              v-model="prescription_care_item.name"
              class="form-control"
            />
          </div>

          <div class="col-md-12">
            <LabelRequiredField label="Status" />

            <select
              v-model="prescription_care_item.active"
              class="form-control"
            >
              <option :value="1">Ativo</option>
              <option :value="0">Inativo</option>
            </select>
          </div>

          <ErrorsMessages :errors="errors" />

          <div class="col-md-12 text-right">
            <v-btn
              :disabled="loading"
              type="submit"
              class="v-success"
              @click="update"
            >
              <span class="fa fa-check"></span>
              {{ loading ? "Carregando" : "Salvar" }}
            </v-btn>
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import ErrorsMessages from "../components/ErrorsMessages";

import LabelRequiredField from "../components/LabelRequiredField";

import api from "../../services/api";

import toast from "../../components/ToastNotification";

export default {
  name: "UpdateModal",

  components: {
    LabelRequiredField,
    ErrorsMessages,
  },

  props: {
    prescription_care_item: {
      type: [Object, Array],
    },
  },

  data() {
    return {
      loading: false,

      errors: [],
    };
  },

  methods: {
    async update() {
      try {
        this.loading = true;

        const id = this.prescription_care_item.id;

        const name = this.prescription_care_item.name;

        const active = this.prescription_care_item.active;

        let params = { id, name, active };

        const response = await api.put(
          "/admin/prescription-care-item/update",
          params
        );

        const { error, errors, message } = response.data;

        if (!error) {
          this.errors = [];

          toast(message, "success");

          this.$bvModal.hide("update-care");

          this.$emit("update");
        } else {
          this.errors = errors;
        }

        this.loading = false;
      } catch (error) {
        this.loading = false;

        console.log(error);
      }
    },

    onModalHide() {
      this.errors = [];

      this.$emit("update-care");
    },
  },
};
</script>